import { useRef } from "react";

import { Menu, ToolIcon } from "@theorgchartdev/storybook";
import { getHoverTipContent } from "@/Utils/Misc";
import {
  CheckBoxCellControlDisabled,
  DeleteRow,
  InsertRow
} from "@/appComponents/Blocks/Composites/LayoutHoverToolbar/Utils";
import { appstr } from "@coreapp/utils/appstr";

export const InsertRowMenu = props => {
  const openCtrlRef = useRef(null);

  const BLEInsertOptions = [
    {
      value: "insertrowabove",
      clickHandler: InsertRow,
      disabled: CheckBoxCellControlDisabled
    },
    {
      value: "insertrowbelow",
      clickHandler: () => InsertRow(false),
      disabled: CheckBoxCellControlDisabled,
      divider: true
    },
    {
      value: "deleterows",
      clickHandler: DeleteRow,
      disabled: CheckBoxCellControlDisabled
    }
  ];

  return (
    <Menu
      openCtrlRef={openCtrlRef}
      optionSize={"small"}
      stayOpenOnOptionSelect
      trigger={
        <ToolIcon
          name={"boxrows"}
          size={"medium-small"}
          tooltipProps={{ ...getHoverTipContent("Row actions"), referenceOpenCtrlRef: openCtrlRef }}
        />
      }
      dataTestId={`${props?.dataTestIdPrefix}-insert-row-menu`}
      options={BLEInsertOptions.map(item => {
        return {
          ...item,
          label: appstr(item.value),
          disabled: item.disabled(item.value),
          dataTestId: `${props?.dataTestIdPrefix}-insert-row-menu-${item.value}`
        };
      })}
    />
  );
};
